export default "__VITE_ASSET__BkdAhXvx__"